import * as React from 'react';

import { IGeoSuggestItem } from '../../../utils/geo';
import { AddressIcon } from '../../icons';

import { ListGroup, ListItem } from './ListGroup';
import { getSuggestLinkText } from './getSuggestLinkText';

interface IAddressSuggestionsProps {
  textValue: string;
  suggests: IGeoSuggestItem[];
  handleItemSelect(suggest: IGeoSuggestItem): void;
}

export const AddressSuggestions: React.FC<IAddressSuggestionsProps> = props => {
  const { suggests, handleItemSelect, textValue } = props;

  return (
    <ListGroup title="Адреса" icon={<AddressIcon />}>
      {suggests.map((suggest: IGeoSuggestItem) => (
        <ListItem key={`suggestion-${suggest.displayName}`} onClick={() => handleItemSelect(suggest)}>
          {getSuggestLinkText(suggest.displayName, textValue)}
        </ListItem>
      ))}
    </ListGroup>
  );
};
